// 框架管理台路由 /system开头
import BasicLayout from '../layouts/BasicLayout'

export default [
  {
    path: '/system',
    component: BasicLayout,
    children: [
      {
        path: '/pkg/list',
        component: () => import('../views/system/Packages'),
        meta: { title: '应用包列表' }
      },
      {
        path: '/pkg/:id/funs',
        component: () => import('../views/system/PackageFunctions'),
        meta: { title: '应用包功能列表' }
      },
      {
        path: '/app/list',
        component: () => import('../views/system/AppList'),
        meta: { title: '应用列表' }
      },
      {
        path: '/app/:id/funs',
        component: () => import('../views/system/AppFunctions'),
        meta: { title: '应用功能列表' }
      },
      {
        path: '/qrtz/list',
        component: () => import('../views/system/QrtzList'),
        meta: { title: '调度列表' }
      },
      {
        path: '/sysdicinfo/list',
        component: () => import('../views/system/SysdicinfoList'),
        meta: { title: '系统字典列表' }
      },
      {
        path: '/parameter/list',
        component: () => import('../views/system/ParameterList'),
        meta: { title: '系统参数列表' }
      },
      {
        path: '/corpPara/list',
        component: () => import('../views/system/CorpParaList'),
        meta: { title: '公司参数列表' }
      },
      {
        path: '/staffInfo/list',
        component: () => import('../views/system/StaffInfoList'),
        meta: { title: '员工管理' }
      },
      {
        path: '/appApplication/list',
        component: () => import('../views/system/AppApplicationList'),
        meta: { title: '应用列表' }
      },
      {
        path: '/flowtab/:pdext_uuid',
        meta: { title: '流程设计器', requireAuth: false },
        component: () => import('../components/Flow/EcpFlow')
      },
      {
        path: '/wf/category',
        component: () => import('../views/wf/WfCategory'),
        meta: { title: '流程分类' }
      },
      {
        path: '/wf/procdef',
        component: () => import('../views/wf/WfProcdef'),
        meta: { title: '流程定义' }
      },
      {
        path: '/wf/todolist',
        component: () => import('../views/wf/WfTodoList'),
        meta: { title: '待办列表' }
      },
      {
        path: '/wf/todohislist',
        component: () => import('../views/wf/WfTodoHisList'),
        meta: { title: '已办列表' }
      },
      {
        path: '/wf/depute',
        component: () => import('../views/wf/WfDepute'),
        meta: { title: '流程委托' }
      },
      {
        path: '/wf/demo1',
        component: () => import('../views/wf/WfDemo1'),
        meta: { title: '流程实例-普通' }
      },
      {
        path: '/wf/demo1/audit/:todoid/:biz_uuid',
        component: () => import('../views/wf/WfDemo1Audit'),
        meta: { title: '流程实例-普通-审核' }
      },
      {
        path: '/wf/demo2',
        component: () => import('../views/wf/WfDemo2'),
        meta: { title: '流程实例-普通' }
      },
      {
        path: '/wf/demo2/audit/:todoid/:biz_uuid',
        component: () => import('../views/wf/WfDemo2Audit'),
        meta: { title: '流程实例-普通-审核' }
      },
      {
        path: '/orgAdmin/list',
        component: () => import('../views/system/OrgAdminList'),
        meta: { title: '组织机构' }
      },
      {
        path: '/wf/demo3',
        component: () => import('../views/wf/WfDemo3'),
        meta: { title: '流程实例-普通' }
      },
      {
        path: '/wf/demo3/audit/:todoid/:biz_uuid',
        component: () => import('../views/wf/WfDemo3Audit'),
        meta: { title: '流程实例-普通-审核' }
      },
      {
        path: '/wf/wfAdjust',
        component: () => import('../views/wf/WfAdjust'),
        meta: { title: '流程实例-普通' }
      },
      {
        path: '/loginAudit/list',
        component: () => import('../views/system/loginAuditList'),
        meta: { title: '登录审计' }
      },
      {
        path: '/menuAudit/list',
        component: () => import('../views/system/MenuAuditList'),
        meta: { title: '访问审计' }
      },
      {
        path: '/org/list',
        component: () => import('../views/system/OrgList'),
        meta: { title: '组织机构' }
      },
      {
        path: '/accountList/list',
        component: () => import('../views/system/AccountList'),
        meta: { title: '账户管理' }
      },
      {
        path: '/avatarRole/list',
        component: () => import('../views/system/AvatarRole'),
        meta: { title: '虚拟角色管理' }
      },
      {
        path: '/uc/passwordPolicy',
        component: () => import('../views/system/PasswordPolicy'),
        meta: { title: '密码策略管理' }
      },
      {
        path: '/sysMsg/list',
        component: () => import('../views/system/SysMsgList'),
        meta: { title: '站内系统消息' }
      },
      {
        path: '/sysHelp/list',
        component: () => import('../views/system/SysHelpList'),
        meta: { title: '系统帮助' }
      },
      {
        path: '/uumRoleFunc/list',
        component: () => import('../views/system/UumRoleFunc'),
        meta: { title: '权限分配管理' }
      },
      {
        path: '/uumRole/list',
        component: () => import('../views/system/UumRole'),
        meta: { title: '角色管理' }
      },
      {
        path: '/esDefaultfield/list',
        component: () => import('../views/system/EsDefaultfieldList'),
        meta: { title: 'ES默认字段管理' }
      },
      {
        path: '/esConfig/list',
        component: () => import('../views/system/EsConfigList'),
        meta: { title: 'ES业务配置管理' }
      },
      {
        path: '/msgCode/list',
        component: () => import('../views/system/MsgCode'),
        meta: { title: '消息编码服务' }
      },
      {
        path: '/groupMaintain/list',
        component: () => import('../views/system/GroupMaintain'),
        meta: { title: '群组维护' }
      },
      {
        path: '/msgService/list',
        component: () => import('../views/system/MsgService'),
        meta: { title: '消息服务配置' }
      },
      {
        path: '/esSearch/list',
        component: () => import('../views/system/EsSearchList'),
        meta: { title: '消息服务配置', keepAlive: true }
      },
      {
        path: '/staffInfoEdit/list',
        component: () => import('../views/system/StaffInfoEdit'),
        meta: { title: '人员信息修改', keepAlive: true }
      },
      {
        path: '/qrcodAdapter/list',
        component: () => import('../views/system/QrcodAdapterList'),
        meta: { title: '识别客户端管理' }
      },
      {
        path: '/qrcodeConfigure/list',
        component: () => import('../views/system/QrcodeConfigureList'),
        meta: { title: '二维码配置管理' }
      },
      {
        path: '/qrcodeMark/list',
        component: () => import('../views/system/QrcodeMarkList'),
        meta: { title: '二维码记录' }
      },
      {
        path: '/componentManager/list',
        component: () => import('../views/system/ComponentManagerList'),
        meta: { title: '角色组件管理' }
      },
      {
        path: '/componentRole/list',
        component: () => import('../views/system/ComponentRoleList'),
        meta: { title: '首页角色维护' }
      },
      {
        path: '/componentTemplate/list',
        component: () => import('../views/system/ComponentTemplateList'),
        meta: { title: '模板管理' }
      }
      , {
        path: '/gridInfo/list',
        component: () => import('../views/system/GridInfo'),
        meta: { title: '表格维护' }
      }
      , {
        path: '/gridInfo/edit',
        component: () => import('../views/system/GridInfoEdit'),
        meta: { title: '表格维护编辑' }
      }
      , {
        path: '/cache/list',
        component: () => import('../views/system/Cache'),
        meta: { title: '缓存管理' }
      }
      , {
        path: '/file/whiteList',
        component: () => import('../views/system/fileWhiteInfo'),
        meta: { title: '文件白名单管理' }
      }
      , {
        path: '/file/list',
        component: () => import('../views/system/fileInfo'),
        meta: { title: '文件查询' }
      }
      , {
        path: '/fileTemplate/list',
        component: () => import('../views/system/fileTemplateInfo'),
        meta: { title: '文件模板查询' }
      }
      , {
        path: '/fileConvert/list',
        component: () => import('../views/system/fileConvertInfo'),
        meta: { title: '文件转换查询' }
      }
      , {
        path: '/fileConvert/view',
        component: () => import('../views/system/fileConvertView'),
        meta: { title: '文件转换详情' }
      }
      , {
        path: '/clientManager/list',
        component: () => import('../views/system/clientManagerInfo'),
        meta: { title: '客户端服务授权' }
      }
      , {
        path: '/serviceManager/list',
        component: () => import('../views/system/serviceManagerInfo'),
        meta: { title: '系统运行服务' }
      }
      , {
        path: '/dm/file',
        component: () => import('../views/system/DmFile'),
        meta: { title: '附件迁移查询' }
      }
      , {
        path: '/dm/fileDetail',
        component: () => import('../views/system/DmFileDetail'),
        meta: { title: '附件迁移查询' }
      }
      , {
        path: '/dm/rule',
        component: () => import('../views/system/DmRule'),
        meta: { title: '迁移规则维护' }
      }
      , {
        path: '/dm/oaTable',
        component: () => import('../views/system/DmOaTable'),
        meta: { title: '公文数据迁移' }
      }
      , {
        path: '/dm/egwTable',
        component: () => import('../views/system/DmEgwTable'),
        meta: { title: '门户数据迁移' }
      }
      , {
        path: '/dm/gaTable',
        component: () => import('../views/system/DmGaTable'),
        meta: { title: '综合事务数据迁移' }
      }
      , {
        path: '/dm/wfTable',
        component: () => import('../views/system/DmWfTable'),
        meta: { title: '流程意见数据迁移' }
      }
      , {
        path: '/dm/tableSet',
        component: () => import('../views/system/DmTableSet'),
        meta: { title: '表设置' }
      }
      , {
        path: '/dm/setting',
        component: () => import('../views/system/DmSetting'),
        meta: { title: '迁移设置' }
      }
      , {
        path: '/dm/query',
        component: () => import('../views/system/DmQuery'),
        meta: { title: '公文数据迁移查询' }
      }
      , {
        path: '/dm/dataDetails',
        component: () => import('../views/system/DmDataDetails'),
        meta: { title: '数据迁移详情' }
      }
      , {
        path: '/dm/oaQuery',
        component: () => import('../views/system/DmOaQuery'),
        meta: { title: '公文数据迁移查询' }
      }
      , {
        path: '/dm/egwQuery',
        component: () => import('../views/system/DmEgwQuery'),
        meta: { title: '门户数据迁移查询' }
      }
      , {
        path: '/dm/gaQuery',
        component: () => import('../views/system/DmGaQuery'),
        meta: { title: '综合事务数据迁移查询' }
      }
      , {
        path: '/dm/wfQuery',
        component: () => import('../views/system/DmWfQuery'),
        meta: { title: '流程意见数据迁移查询' }
      }
      , {
        path: '/dm/org',
        component: () => import('../views/system/DmOrg'),
        meta: { title: '组织数据迁移' }
      }
      , {
        path: '/dm/user',
        component: () => import('../views/system/DmUser'),
        meta: { title: '用户数据迁移查询' }
      }
    ]
  },
  {
    path: '/flow/:pdext_uuid',
    meta: { title: '流程设计器', requireAuth: false },
    component: () => import('../components/Flow/EcpFlow')
  }

]